import moment from "moment";

import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";

export default function FormCalendar(props) {
  const {
    className,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true },
    data: {
      uiClassName,
      name,
      placeholder = "",
      dateFormat = "yy/mm/dd",
      showTime = false,
      showSeconds = false,
      minDate,
      maxDate,
      disabled = false,
      saveFun = () => {},
    },
  } = props;

  const onChange = (e, field) => {
    field.onChange(e.value ? moment(e.value).format("YYYY/MM/DD") : null);

    saveFun();

    if (isSubmitted) {
      trigger();
    } else {
      trigger(field.name);
    }
  };

  return (
    <>
      <Controller
        key={name}
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <div
            className={classNames(
              "flex align-items-center flex-auto",
              className
            )}
          >
            <Calendar
              id={field.name}
              className={classNames(
                { "p-invalid": fieldState.invalid },
                "w-full",
                uiClassName
              )}
              {...field}
              value={field.value ? new Date(field.value) : null}
              onChange={(e) => onChange(e, field)}
              placeholder={placeholder}
              minDate={minDate ? new Date(minDate) : null}
              maxDate={maxDate ? new Date(maxDate) : null}
              disabled={!isEdit || disabled}
              dateFormat={dateFormat}
              showTime={showTime}
              showSeconds={showSeconds}
              showIcon
              showButtonBar
            />
          </div>
        )}
      />
    </>
  );
}
